export const IMAGES = {
    hero: {
        src: "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?auto=format&fit=crop&w=2400&q=85",
        alt: "Snow-capped Himalayan peaks rising above a quiet layer of clouds",
    },
    bespokeHero: {
        src: "https://images.unsplash.com/photo-1485470733090-0aae1788d5af?auto=format&fit=crop&w=2400&q=85",
        alt: "Mountain summits under a starry night sky — present, yet unseen",
    },
    about: {
        src: "https://images.unsplash.com/photo-1604223190546-a43e4c7f29d7?auto=format&fit=crop&w=1600&q=85",
        alt: "Layered mountain ridges under a warm evening sky",
    },
    onYourOwn: {
        src: "https://images.unsplash.com/photo-1600721212034-b34ed8899f80?auto=format&fit=crop&w=1200&q=85",
        alt: "A traveller walking alone across wide desert dunes",
    },
    guidedGroup: {
        src: "https://images.unsplash.com/photo-1574060275764-4e3e046ff29c?auto=format&fit=crop&w=1200&q=85",
        alt: "Warm lanterns lighting a narrow street in Japan at night",
    },
    bespoke: {
        src: "https://images.unsplash.com/photo-1770886907289-29e1d53c2527?auto=format&fit=crop&w=1200&q=85",
        alt: "Historic buildings reflected in a calm European canal at sunset",
    },
};

export const CONTACTS = [
    {
        name: "Dnyanada",
        fullName: "Dnyanada Abhijit Deshmukh",
        role: "Co-founder · Travel enthusiast",
        phoneDisplay: "+91 73872 56077",
        tel: "+917387256077",
        whatsapp: "https://wa.me/917387256077",
        initial: "D",
    },
    {
        name: "Abhijit",
        fullName: "Abhijit Vijaykumar Deshmukh",
        role: "Co-founder · Travel enthusiast",
        phoneDisplay: "+91 84120 33559",
        tel: "+918412033559",
        whatsapp: "https://wa.me/918412033559",
        initial: "A",
    },
];

export const WA_FLOAT =
    "https://wa.me/917387256077?text=" +
    encodeURIComponent("Hello Dnyanada & Abhijit, I'd like to plan a journey.");

export const PACKAGES = [
    {
        numeral: "I",
        name: "On Your Own Tour",
        kicker: "Curated itinerary & booking support",
        tag: null,
        imageKey: "onYourOwn",
        blurb:
            "Expert planning and complete booking support. You travel independently, with none of the guesswork.",
        includes: [
            "Real-experience consultation",
            "Curated day-by-day itinerary",
            "Booking assistance for stays, flights, transfers, tickets & activities",
            "Visa guidance",
        ],
        idealFor: "Independent travellers, budget-conscious families, first-time explorers",
    },
    {
        numeral: "II",
        name: "Guided Group Tour",
        kicker: "Small-group journey",
        tag: "Most Popular",
        imageKey: "guidedGroup",
        blurb:
            "A shared journey with like-minded travellers, led by a dedicated guide who looks after every detail from arrival to departure.",
        includes: [
            "Set group itinerary",
            "Stays, transfers & sightseeing arranged",
            "24/7 on-ground support",
            "Local & cultural context",
            "Visa assistance",
        ],
        idealFor: "Solo travellers, first-time international travellers, zero-hassle holidays",
    },
    {
        numeral: "III",
        name: "Bespoke Private Tour",
        kicker: "Fully private · entirely yours",
        tag: "Ultimate",
        imageKey: "bespoke",
        blurb:
            "You define everything and approve every element before booking. Nothing is confirmed without your sign-off.",
        includes: [
            "Consultation sessions with senior travel architects",
            "Full itinerary ownership — you approve every element",
            "Private guide following the HIT but HINT philosophy",
            "Priority partnerships & preferred rates",
            "Dedicated consultant & post-trip follow-up",
        ],
        idealFor: "Families up to ten, special occasions, corporate retreats, luxury holidays",
        link: "/bespoke",
    },
];

export const COMPARE = {
    packages: ["On Your Own", "Guided Group", "Bespoke Private"],
    rows: [
        { label: "Curated personalised itinerary", avail: [true, false, true] },
        { label: "Booking assistance — stays, flights, tickets", avail: [true, false, true] },
        { label: "Visa guidance", avail: [true, true, true] },
        { label: "Tour guide on the trip", avail: [false, true, true] },
        { label: "Private guide · HIT but HINT", avail: [false, false, true] },
        { label: "24/7 on-ground support", avail: [false, true, true] },
        { label: "Private, one-party-only journey", avail: [false, false, true] },
        { label: "100% traveller-defined — dates, airline, hotels", avail: [false, false, true] },
        { label: "Dedicated consultant & post-trip follow-up", avail: [false, false, true] },
    ],
};

export const DESTINATIONS = [
    {
        region: "Asia & Middle East",
        places: ["Singapore", "Dubai", "Japan", "Hong Kong", "Vietnam"],
        note: null,
    },
    {
        region: "Europe",
        places: [
            "France",
            "Netherlands",
            "United Kingdom",
            "Germany",
            "Switzerland",
            "Italy",
            "Spain",
            "Greece",
            "Sweden",
            "Denmark",
            "Norway",
            "Finland",
        ],
        note: "Eastern Europe — Prague, Budapest, Krakow, Ljubljana",
    },
    {
        region: "Americas, Oceania & Africa",
        places: ["Australia", "New Zealand", "USA", "Canada", "Mexico", "South Africa"],
        note: null,
    },
];

export const ACTIVITIES = [
    "Walking Tours",
    "Live Like a Local",
    "Cycling",
    "Hiking",
    "Paragliding",
    "Scuba Diving",
    "Food, Wine & Farms",
    "Nature Trails",
];

export const STEPS = [
    {
        numeral: "01",
        title: "Consult",
        body: "A free conversation about where you're going, who's coming, and what 'your way' looks like.",
    },
    {
        numeral: "02",
        title: "Curate",
        body: "We design the journey, and you approve every stay, guide and activity before anything is booked.",
    },
    {
        numeral: "03",
        title: "Travel",
        body: "Visa, flights and ground support handled — you simply arrive and begin.",
    },
];

export const SCROLL = {
    go: (id) => {
        if (id === "top") {
            if (window.__lenis) window.__lenis.scrollTo(0);
            else window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        const el = document.getElementById(id);
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64 });
        else
            window.scrollTo({
                top: el.getBoundingClientRect().top + window.scrollY - 64,
                behavior: "smooth",
            });
    },
};
